import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, query, where, getDocs, updateDoc, doc, getDoc, deleteDoc, setDoc, onSnapshot, writeBatch, orderBy } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';


// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

let userID = null; // Define userID here

// Function to asynchronously get the user ID
const getUserID = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        console.log("User is signed in with UID:", user.uid);
        const docRef = doc(db, 'Users', user.uid, 'capital', 'capital');
        setDoc(docRef, { deposits:0, withdrawals:0 });
        unsubscribe(); // Stop listening for changes
        resolve(user.uid);
      } else {
        // User is signed out
        console.log("No user is signed in.");
        resolve(null);
      }
    }, (error) => {
      // Error occurred while retrieving authentication state
      console.error("Error getting authentication state:", error);
      reject(error);
    });
  });
};

// Function to add trade data to Firestore
const addTrade = async (tradeData) => {
  try {
    const docRef = await addDoc(collection(db, "Users", userID, "trades"), tradeData);
    console.log('Trade data added with ID:', docRef.id);
  } catch (error) {
    console.error('Error adding trade data:', error);
  }
};

export { app, db, auth, userID, addTrade, where, getDocs, query, collection, updateDoc, doc, getDoc, addDoc, deleteDoc, getUserID, signInWithEmailAndPassword, getAuth, onSnapshot, setDoc, writeBatch, orderBy };
